import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, List } from 'antd'
import axios from 'axios'

const AdminNonAutoCountLocation = ({ visible, onClose }) => {
  const [locations, setLocations] = useState([])
  const [newLocation, setNewLocation] = useState('') // State for new location input
  const [loading, setLoading] = useState(false)

  // Fetch locations when the modal is visible
  useEffect(() => {
    if (visible) {
      fetchLocations()
    }
  }, [visible])

  // Fetch all locations from the API
  const fetchLocations = async () => {
    try {
      setLoading(true)
      const { data } = await axios.get(
        '/api/v1/admin/non-autocount/get-location'
      )
      setLocations(data)
    } catch (error) {
      console.error('Error fetching locations:', error)
    } finally {
      setLoading(false)
    }
  }

  // Add a new location
  const addLocation = async () => {
    if (!newLocation.trim()) return // Prevent empty location submission

    try {
      const { data } = await axios.post(
        '/api/v1/admin/non-autocount/add-new-location',
        { locationName: newLocation }
      )
      setLocations((prev) => [...prev, data]) // Add the new location to the list
      setNewLocation('') // Clear input
    } catch (error) {
      console.error('Error adding location:', error)
    }
  }

  // Delete a location
  const deleteLocation = async (locationId) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this location?'
    )
    if (!confirmDelete) return

    try {
      await axios.delete(
        `/api/v1/admin/non-autocount/delete-location/${locationId}`
      )
      setLocations((prev) =>
        prev.filter((location) => location._id !== locationId)
      ) // Remove from UI
    } catch (error) {
      console.error('Error deleting location:', error)
    }
  }

  return (
    <Modal
      title='Location List'
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key='close' onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      {/* Input field to add new locations */}
      <div style={{ display: 'flex', marginBottom: '10px' }}>
        <Input
          value={newLocation}
          onChange={(e) => setNewLocation(e.target.value)}
          placeholder='Add new location'
          style={{ marginRight: '10px' }}
        />
        <Button
          type='primary'
          onClick={addLocation}
          disabled={!newLocation.trim()}
        >
          Add
        </Button>
      </div>

      {/* Display loading status */}
      {loading ? (
        <p>Loading locations...</p>
      ) : locations.length === 0 ? (
        <p>No locations available</p>
      ) : (
        <List
          bordered
          dataSource={locations}
          renderItem={(location) => (
            <List.Item
              actions={[
                <Button
                  type='link'
                  danger
                  onClick={() => deleteLocation(location._id)}
                >
                  Delete
                </Button>,
              ]}
            >
              {location.locationName}
            </List.Item>
          )}
        />
      )}
    </Modal>
  )
}

export default AdminNonAutoCountLocation
